import React, {Component} from 'react';
import classnames from 'classnames';
import {MoreContainer} from './style';
import {promotionMore} from '../../../utils/status'
import {isEmpty, objDeepCopy} from '../../../utils/tool'

class MoreItem extends Component {
  constructor(props) {
    super(props);
    const {noticeStatus, referenceValue} = promotionMore;
    const {MoreItem} = this.props.store;
    if (MoreItem) {
      this.state = MoreItem;
    } else {
      this.state = {
        noticeStatus: objDeepCopy(noticeStatus),
        referenceValue: objDeepCopy(referenceValue),
      }
    }
  }

  componentDidMount() {
  }

  btnGroup = () => {
    return (
      <div className="group-container">
        <div
          onClick={() => {
            this.reset()
          }}
          className="btn-item">重置
        </div>
        <div
          className="btn-item confirm"
          onClick={() => {
            this.confirm()
          }}
        >确定
        </div>
      </div>
    )
  }

  titleCard = (props) => {
    const {title, filterItems, children, name} = props;
    return (
      <div className="title-card">
        <h6 className="title">{title}</h6>
        {
          !filterItems &&
          (
            React.cloneElement(children)
          )
        }
        {
          filterItems && filterItems.length !== 0 &&
          (
            <div className="content">
              {
                filterItems.map((filterItem, index) => {
                  return (
                    <div
                      key={filterItem.text}
                      className={classnames(["filter-item", {
                        'actived': !!filterItem.selected,
                      }])}
                      onClick={() => {
                        let newFilterItems = objDeepCopy(filterItems);
                        newFilterItems.forEach(value => {
                          value['selected'] = false
                        })
                        newFilterItems[index].selected = true;
                        this.setState({
                          [name]: newFilterItems
                        })
                      }}
                    >
                      {filterItem.text}
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
    )
  }

  reset = () => {
    const {noticeStatus, referenceValue} = promotionMore;
    this.setState({
      noticeStatus: objDeepCopy(noticeStatus),
      referenceValue: objDeepCopy(referenceValue),
    })
  }

  confirm = () => {
    let condition = {};
    const {noticeStatus,referenceValue} = this.state;
    let activedArr = noticeStatus.filter((value) => value.selected);
    let referenceActivedArr = referenceValue.filter((value) => value.selected);

    if (isEmpty(activedArr)) {
      // 全部为空
      condition = Object.assign(condition, {
        merchantsStatus: 'none',
      })
    } else {
      condition = Object.assign(condition, activedArr[0].condition)
    }

    if (isEmpty(referenceActivedArr)) {
      // 全部为空
      condition = Object.assign(condition, {
        referenceLowerLimit: 'none',
        referenceUpperLimit: 'none',
      })
    } else {
      condition = Object.assign(condition, referenceActivedArr[0].condition)
    }

    // 暂存数据
    const {saveCurrData, addCondition} = this.props.store;
    saveCurrData('MoreItem', this.state);

    // 增加选择条件
    addCondition(condition, true);
    const {closeFilter} = this.props;
    closeFilter();
  }

  render() {
    const {noticeStatus, referenceValue} = this.state;
    return (
      <MoreContainer>
        {
          this.titleCard({
            name: 'noticeStatus',
            title: '公告状态',
            filterItems: noticeStatus,
          })
        }
        {
          this.titleCard({
            name: 'referenceValue',
            title: '参考价值',
            filterItems: referenceValue,
          })
        }
        {
          this.btnGroup()
        }
      </MoreContainer>
    );
  }
}

export default MoreItem;

